import React from "react";
import { HStack, Text, VStack } from "@commonsku/design-system";
import { isNoteComplete } from "../../../redux/notes";
import { MyTasksListKey, TaskNote } from "../../../redux/myTasks";
import { getTaskHref } from "./taskHref";
import TaskLeadingControl from "./TaskLeadingControl";
import TaskClickThrough from "./TaskClickThrough";
import TaskMessageText from "./TaskMessageText";
import TaskSecondaryLine from "./TaskSecondaryLine";

export interface TaskListItemProps {
  tab: MyTasksListKey;
  note: TaskNote;
  onToggleComplete: (noteId: string, complete: boolean) => void;
  /** Overrides the row's top padding — used to remove the gap above a section's first item. */
  paddingTop?: string;
}

/** One task row: a leading control, the task itself, and a click-through to its parent record. */
const TaskListItem = ({ tab, note, onToggleComplete, paddingTop = "1.5" }: TaskListItemProps) => {
  const complete = isNoteComplete(note);

  return (
    <HStack gap="2" paddingX="2" paddingTop={paddingTop} paddingBottom="1.5" alignItems="flex-start">
      <TaskLeadingControl tab={tab} note={note} complete={complete} onToggleComplete={onToggleComplete} />
      <TaskClickThrough href={getTaskHref(note)}>
        <VStack align="start" gap="0.5">
          <TaskMessageText html={note.message_text} />
          {note.parent_name && (
            <Text fontSize="xs" fontWeight="bold" colorPalette="brand" color="colorPalette.fg" margin="0">
              {note.parent_name}
            </Text>
          )}
          <Text fontSize="xs" color="fg.muted" margin="0">
            <TaskSecondaryLine tab={tab} note={note} complete={complete} />
          </Text>
        </VStack>
      </TaskClickThrough>
    </HStack>
  );
};

export default TaskListItem;
